import { html } from './utils/core.js';
import { Router, LocationProvider, lazy, useLocation } from 'preact-iso';
import { routes } from './routes.js';

const RouteComponents = await Promise.all(
  routes.map((Route) => Route.async
    ? lazy(Route.loader)
    : Route.loader())
);

const mappedRouteComponents = RouteComponents.map(
  // "RouteComponent.default" refers to synchronous components, "RouteComponent" to async components
  (RouteComponent, index) =>
    html`
      <${RouteComponent.default || RouteComponent}
        path=${routes[index].path}
        ...${routes[index].props}
      />
    `
);

function updateRouteView(url) {
  const routeConfig = routes.find(({ path }) => path === url);
  if (!routeConfig) return;

  const { title } = routeConfig;

  if (title && title !== document.title) {
    document.title = title;
  }
}

function PageContainer({ children }) {
  return html`
    <main class="page-container">
      ${children}
    </main>`;
}

export default function App({ children: pageBody }) {

  // Server-side rendering
  if (typeof window === 'undefined') {
    return html`<${PageContainer}>${pageBody}<//>`;
  }

  return html`
    <${LocationProvider}>
      <${PageContainer}>
        <${Router} onRouteChange="${updateRouteView}">
          ${mappedRouteComponents}
        <//>
      <//>
    <//>
  `;
}
